// useNowTick — returns the current timestamp, updated every `intervalMs`.
// Lets countdown displays re-render once per second from a single timer
// at the page level instead of one timer per row.
//
//   const now = useNowTick(1000);
//   const secondsLeft = Math.floor((deadline - now) / 1000);

import { useEffect, useState } from "react";

export function useNowTick(intervalMs = 1000) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(t);
  }, [intervalMs]);
  return now;
}
